(function () {
  'use strict';

  var documentElement = document.documentElement;

  function syncAnnouncementHeight() {
    var announcement = document.querySelector('.bpc-utility-bar');
    var height = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    documentElement.style.setProperty('--bpc-announcement-height', height + 'px');
  }

  function initAnnouncement() {
    syncAnnouncementHeight();
    window.addEventListener('resize', syncAnnouncementHeight);

    var announcement = document.querySelector('.bpc-utility-bar');
    if (announcement && window.ResizeObserver) {
      var observer = new window.ResizeObserver(syncAnnouncementHeight);
      observer.observe(announcement);
    }
  }

  function closeCategoryMenus(exceptButton) {
    document.querySelectorAll('[data-bpc-category-toggle]').forEach(function (button) {
      if (button === exceptButton) return;
      var panelId = button.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      button.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function initCategoryNavigation(scope) {
    scope.querySelectorAll('[data-bpc-category-toggle]').forEach(function (button) {
      if (button.getAttribute('data-bpc-bound') === 'true') return;
      button.setAttribute('data-bpc-bound', 'true');

      button.addEventListener('click', function () {
        var panelId = button.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;

        var willOpen = button.getAttribute('aria-expanded') !== 'true';
        closeCategoryMenus(willOpen ? button : null);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.hidden = !willOpen;
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeCategoryMenus();
        button.focus();
      });
    });
  }

  function initCategoryDismissal() {
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.bpc-category-nav__item')) closeCategoryMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCategoryMenus();
    });
  }

  function initDrawerState() {
    var lastTrigger = null;
    var wasOpen = document.body.classList.contains('pushy-active');

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.pushy-menu-btn');
      if (trigger) lastTrigger = trigger;
    }, true);

    function update() {
      var isOpen = document.body.classList.contains('pushy-active');
      document.querySelectorAll('.pushy-menu-btn').forEach(function (button) {
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        button.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      });

      if (isOpen && !wasOpen) {
        window.setTimeout(function () {
          var closeButton = document.querySelector('.bpc-menu-drawer__close');
          if (closeButton) closeButton.focus();
        }, 0);
      }

      if (!isOpen && wasOpen) {
        var drawer = document.querySelector('.bpc-menu-drawer');
        if (lastTrigger && (!drawer || drawer.contains(document.activeElement))) {
          window.setTimeout(function () { lastTrigger.focus(); }, 0);
        }
      }

      wasOpen = isOpen;
    }

    update();
    if (window.MutationObserver) {
      var observer = new MutationObserver(update);
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function initPredictiveSearch(scope) {
    scope.querySelectorAll('[data-bpc-predictive-search]').forEach(function (component) {
      if (component.getAttribute('data-bpc-bound') === 'true') return;

      var input = component.querySelector('[data-bpc-predictive-input]');
      var results = component.querySelector('[data-bpc-predictive-results]');
      var baseUrl = component.getAttribute('data-predictive-url') || '/search/suggest';
      var timer;
      var controller;
      var activeQuery = '';

      if (!input || !results) return;
      component.setAttribute('data-bpc-bound', 'true');

      function close() {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      function open() {
        if (!results.innerHTML.trim()) return;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function resultLinks() {
        return Array.prototype.slice.call(results.querySelectorAll('a'));
      }

      function requestResults(query) {
        if (query.length < 2) {
          activeQuery = '';
          if (controller) controller.abort();
          results.innerHTML = '';
          close();
          return;
        }

        activeQuery = query;
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        input.setAttribute('aria-busy', 'true');

        var joiner = baseUrl.indexOf('?') === -1 ? '?' : '&';
        var url = baseUrl + joiner +
          'q=' + encodeURIComponent(query) +
          '&resources[type]=product' +
          '&resources[limit]=6' +
          '&resources[options][unavailable_products]=last' +
          '&section_id=predictive-search';

        fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller ? controller.signal : undefined
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search request failed');
            return response.text();
          })
          .then(function (html) {
            if (activeQuery !== query || input.value.trim() !== query) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var renderedSection = parsed.querySelector('#shopify-section-predictive-search');
            results.innerHTML = renderedSection ? renderedSection.innerHTML : html;
            resultLinks().forEach(function (link) { link.setAttribute('tabindex', '-1'); });
            convertPrices([results]);
            open();
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') close();
          })
          .then(function () {
            if (activeQuery === query) input.removeAttribute('aria-busy');
          });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { requestResults(query); }, 220);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim() === activeQuery) open();
      });

      input.addEventListener('keydown', function (event) {
        var links = resultLinks();
        if (event.key === 'ArrowDown' && !results.hidden && links.length) {
          event.preventDefault();
          links[0].focus();
        }
        if (event.key === 'Escape') {
          close();
          input.select();
        }
      });

      results.addEventListener('keydown', function (event) {
        var links = resultLinks();
        var currentIndex = links.indexOf(document.activeElement);

        if (event.key === 'ArrowDown' && links.length) {
          event.preventDefault();
          links[Math.min(currentIndex + 1, links.length - 1)].focus();
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (currentIndex <= 0) input.focus();
          else links[currentIndex - 1].focus();
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          input.focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (!component.contains(event.target)) close();
      });
    });
  }

  function convertPrices(roots) {
    if (!window.Currency || !window.shopCurrency || !window.Currency.currentCurrency) return;
    if (window.Currency.currentCurrency === window.shopCurrency) return;

    roots.forEach(function (root) {
      var prices = root.querySelectorAll('span.money');
      if (prices.length) {
        window.Currency.convertAll(window.shopCurrency, window.Currency.currentCurrency, prices);
      }
    });
  }

  function revealNewImages(items) {
    convertPrices(items);
    if (!window.lazySizes || !window.lazySizes.loader) return;
    items.forEach(function (item) {
      item.querySelectorAll('.lazyload').forEach(function (image) {
        window.lazySizes.loader.unveil(image);
      });
    });
  }

  function refreshReviewWidgets() {
    try {
      if (window.SPR) {
        if (window.SPR.initDomEls) window.SPR.initDomEls();
        if (window.SPR.loadBadges) window.SPR.loadBadges();
      }
      if (window.yotpo && window.yotpo.refreshWidgets) window.yotpo.refreshWidgets();
    } catch (error) {
      /* Review integrations remain non-blocking if an app is unavailable. */
    }
  }

  function hasLegacyCatalogPricing() {
    if (!window.BOLD || !window.BOLD.apps_installed) return false;
    var installed = typeof window.BOLD.apps_installed === 'string'
      ? window.BOLD.apps_installed
      : JSON.stringify(window.BOLD.apps_installed);
    return /(Customer Pricing|Product Bundles|Product Discount|Quantity Breaks|Custom Order)/i.test(installed);
  }

  function initProgressiveSearch(scope) {
    var results = scope.querySelector('[data-bpc-search-results]');
    if (!results || results.getAttribute('data-bpc-bound') === 'true') return;

    var controls = results.querySelector('[data-bpc-search-controls]');
    var nextLink = results.querySelector('[data-bpc-search-next]');
    var status = results.querySelector('[data-bpc-search-status]');
    var loading = false;
    var observer;

    if (!controls || !nextLink) return;

    if (hasLegacyCatalogPricing()) {
      var compatibilityLabel = nextLink.querySelector('[data-bpc-search-next-label]');
      if (compatibilityLabel) compatibilityLabel.textContent = 'Next 48 products';
      nextLink.setAttribute('title', 'Open the next 48 products');
      return;
    }

    results.setAttribute('data-bpc-bound', 'true');

    function setLoading(isLoading) {
      var spinner = nextLink ? nextLink.querySelector('[data-bpc-search-spinner]') : null;
      var label = nextLink ? nextLink.querySelector('[data-bpc-search-next-label]') : null;
      loading = isLoading;
      if (!nextLink) return;
      nextLink.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (spinner) spinner.hidden = !isLoading;
      if (label) label.textContent = isLoading ? 'Loading products' : 'Load more products';
    }

    function observeNextLink() {
      if (!window.IntersectionObserver || !nextLink) return;
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadNextPage();
        }, { rootMargin: '650px 0px' });
      }
      observer.disconnect();
      observer.observe(nextLink);
    }

    function loadNextPage(event) {
      if (event) event.preventDefault();
      if (loading || !nextLink || !nextLink.href) return;

      setLoading(true);
      fetch(nextLink.href, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search results request failed');
          return response.text();
        })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var sourceResults = page.querySelector('[data-bpc-search-results]');
          var sourceStatus = page.querySelector('[data-bpc-search-status]');
          var sourceNext = page.querySelector('[data-bpc-search-next]');

          if (!sourceResults) throw new Error('Search results markup missing');

          var newItems = Array.prototype.slice.call(sourceResults.querySelectorAll('[data-bpc-search-item]'));
          newItems.forEach(function (item) {
            results.insertBefore(document.importNode(item, true), controls);
          });

          var appendedItems = newItems.length
            ? Array.prototype.slice.call(results.querySelectorAll('[data-bpc-search-item]')).slice(-newItems.length)
            : [];
          revealNewImages(appendedItems);
          refreshReviewWidgets();

          if (sourceStatus && status) status.textContent = sourceStatus.textContent.trim();

          if (sourceNext) {
            nextLink.href = sourceNext.href;
            setLoading(false);
            observeNextLink();
          } else {
            if (observer) observer.disconnect();
            nextLink.remove();
            nextLink = null;
            loading = false;
          }

          if (window.jQuery && window.jQuery.fn.matchHeight && window.jQuery.fn.matchHeight._update) {
            window.jQuery.fn.matchHeight._update(true);
          }
        })
        .catch(function () {
          setLoading(false);
          if (status) status.textContent = 'More products could not be loaded. Use the button to try again.';
        });
    }

    nextLink.addEventListener('click', loadNextPage);
    observeNextLink();
  }

  function syncCartLabels() {
    var countElement = document.querySelector('.count-items');
    var count = countElement && countElement.textContent.trim() ? countElement.textContent.trim() : '0';
    document.querySelectorAll('.cart-modal-popup').forEach(function (trigger) {
      trigger.setAttribute('aria-label', 'Cart with ' + count + ' items');
      var hiddenLabel = trigger.querySelector('.visuallyhidden');
      if (hiddenLabel) hiddenLabel.textContent = 'You have ' + count + ' items in your cart';
    });
  }

  function initCartLabelObserver() {
    syncCartLabels();
    var counts = document.querySelectorAll('.count-items');
    if (!window.MutationObserver || !counts.length) return;
    var observer = new MutationObserver(syncCartLabels);
    counts.forEach(function (count) {
      observer.observe(count, { childList: true, characterData: true, subtree: true, attributes: true });
    });
  }

  function initialize(scope) {
    initCategoryNavigation(scope);
    initPredictiveSearch(scope);
    initProgressiveSearch(scope);
    syncAnnouncementHeight();
  }

  function ready() {
    initAnnouncement();
    initCategoryDismissal();
    initDrawerState();
    initCartLabelObserver();
    initialize(document);

    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
